import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { ReminderColumnName } from '../../components/reminder-error-table/remonder-confirm-table.component';
import { useTranslation } from 'react-i18next';
import { compact } from 'lodash';
import { Typography } from '@mui/material';
import { mergeSx } from 'merge-sx';
import { useMemo } from 'react';
import { tableCellTypographyOverflowStyles } from '../../../_core/styles';

const helper = createColumnHelper<{
	columnName: string;
	columnValue: string;
	rowIndex: number;
	engagementTitle: string;
	message: string;
	createdObject: any;
}>();

export function useReminderErrorsTableColumns(
	reminderConfirmColumnsList: ReminderColumnName[]
): ColumnDef<any, string>[] {
	const [t] = useTranslation();
	const result = useMemo(
		() => [
			helper.accessor('engagementTitle', {
				//header: t('engagements.columns.title'),
				meta: {
					flex: 2,
					useCustomOverflowContainer: true,
				},
				enableSorting: false,
				cell: ({ getValue }) => (
					<Typography data-overflow="true" sx={tableCellTypographyOverflowStyles}>
						{getValue()}
					</Typography>
				),
			}) as ColumnDef<any, string>,

			helper.accessor('message', {
				//header: 'Message',
				meta: {
					flex: 1,
					useCustomOverflowContainer: true,
				},
				enableSorting: false,
				cell: ({ getValue }) => (
					<Typography
						data-overflow="true"
						sx={{
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap',
							color: (theme) => theme.colors.grayLightBlue,
						}}
					>
						{getValue()}
					</Typography>
				),
			}) as ColumnDef<any, string>,
		],
		[t]
	);

	return result;
}
